module.exports = __webpack_public_path__ + "static/media/valueicon6.d12172db.svg";